module.exports = __webpack_public_path__ + "img/830-0c3e61.png";